import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function BhashiniLoader() {
  const excludedRoutes = new Set([
    "/login_otp",
    "/login_email",
    "/registration",
    "/register_as_support_staff",
    "/register_as_athlete",
    "/register_as_other",
    "/forget-password",
    "/otp-verification",
    "/individual",
    "/create-new-password",
    "/final-submit_individual_registration",
    "/auth_registration",
    "/register_as",
    "/final-status",
    "/otp-verfication",
    "/login/mobile",
  ]);
  const routerLocation = useLocation();
  const [loading, setLoading] = useState(false);
  const isAllowedRoute = !excludedRoutes.has(routerLocation.pathname);
  // useEffect(() => {
  //   const container = document.getElementById("bhashini-plugin-root");
  //   // Skip if the route is in the excluded Set or container not found
  //   if (excludedRoutes.has(routerLocation.pathname) || !container) {
  //     return;
  //   }
  //   const script = document.createElement("script");
  //   script.src =
  //     "https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js";
  //   script.async = true;
  //   script.setAttribute("language-icon-color", "#000");
  //   document.body.appendChild(script);
  //   return () => {
  //     // Clean up when navigating away
  //     if (container.contains(script)) {
  //       container.removeChild(script);
  //     }
  //   };
  // }, [routerLocation.pathname]);
  useEffect(() => {
    if (!isAllowedRoute) return;

    let retries = 0;
    const maxRetries = 15;

    const interval = setInterval(() => {
      const container = document.getElementById("bhashini-plugin-root");

      // Wait until the Bhashini container is present
      if (container) {
        clearInterval(interval);

        // Prevent duplicate script load
        if (document.querySelector('script[src*="bhashini.co.in"]')) {
          console.log("Bhashini script already loaded");
          return;
        }

        console.log("Injecting Bhashini script...");
        const script = document.createElement("script");
        script.src =
          "https://translation-plugin.bhashini.co.in/v3/website_translation_utility.js";
        script.async = true;
        script.setAttribute("language-icon-color", "#000");
        script.onload = () => console.log("Bhashini loaded successfully");
        script.onerror = () => console.error("Bhashini failed to load");
        document.body.appendChild(script);

        // Handle clicks for language selection
        const handleClick = (e) => {
          if (e.target.closest(".bhashini-language-item, button, li, a")) {
            setLoading(true);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        };
        container.addEventListener("click", handleClick);

        // Cleanup on unmount
        return () => {
          container.removeEventListener("click", handleClick);
        };
      } else if (++retries >= maxRetries) {
        clearInterval(interval);
        console.warn("Bhashini container not found after retries");
      }
    }, 300);

    return () => clearInterval(interval);
  }, [routerLocation.pathname, isAllowedRoute]);
  return null; // script loads globally
}

export default BhashiniLoader;
